import { render, staticRenderFns } from "./EmailEntry.vue?vue&type=template&id=48e893c8&scoped=true&"
import script from "./EmailEntry.vue?vue&type=script&lang=ts&"
export * from "./EmailEntry.vue?vue&type=script&lang=ts&"
import style0 from "./EmailEntry.vue?vue&type=style&index=0&id=48e893c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e893c8",
  null
  
)

export default component.exports